// Share utilities - encode/decode Ge'ez text with metadata
import { splitWords } from './textSpacing';

const SHARE_VERSION = '1.2'; 
const SHARE_SCHEMA = 'geez-text';

export function createShareData(text, audioState = null, metadata = {}) {
  const shareObject = {
    schema: SHARE_SCHEMA,
    version: SHARE_VERSION,
    timestamp: new Date().toISOString(),
    text,
    audioState, 
    metadata: {
      charCount: [...text].length,
      wordCount: splitWords(text).length,
      uniqueChars: new Set([...text]).size,
      ...metadata,
    },
  };

  const json = JSON.stringify(shareObject);
  const base64 = btoa(unescape(encodeURIComponent(json)));
  return { json, base64, object: shareObject };
}

export function parseShareData(base64) {
  try {
    const json = decodeURIComponent(escape(atob(base64)));
    const data = JSON.parse(json);
    if (data.schema !== SHARE_SCHEMA && data.schema !== "amharic-text") throw new Error('Invalid schema');
    return data;
  } catch (e) {
    console.error('Failed to parse share data:', e);
    return null;
  }
}

export function copyToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    return navigator.clipboard.writeText(text);
  }
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
  return Promise.resolve();
}

export function generateShareLink(base64) {
  const params = new URLSearchParams({ d: base64 });
  return `${window.location.origin}${window.location.pathname}?${params.toString()}`;
}

export function loadFromURL() {
  const params = new URLSearchParams(window.location.search);
  const data = params.get('d');
  return data ? parseShareData(data) : null;
}